import { createFileRoute, Link } from '@tanstack/react-router';
import { Settings } from 'lucide-react';
import { useTranslator } from '@/hooks/useTranslator';
import { OrdersLayout } from '../../-components/OrdersLayout';

function OrdersLayoutPage() {
  const { getTranslation: t } = useTranslator({ page: 'orders' });
  const { getTranslation: tShared } = useTranslator({ page: 'shared' });

  const tabs = [
    {
      key: 'sales-orders',
      label: t('tabs.salesOrders'),
      to: '/orders/sales-orders',
    },
    {
      key: 'purchase-orders',
      label: t('tabs.purchaseOrders'),
      to: '/orders/purchase-orders',
    },
    {
      key: 'internal-orders',
      label: t('tabs.internalOrders'),
      to: '/orders/internal-orders',
    },
  ];

  const preferences = (
    <Link
      to='/orders/attachment-templates'
      className='inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium text-foreground/80 hover:bg-accent hover:text-foreground transition-colors'
    >
      <Settings className='size-3.5 shrink-0' />
      {t('list.preferences')}
    </Link>
  );

  return (
    <OrdersLayout
      tabs={tabs}
      moreLabel={tShared('moreTabs')}
      endContent={preferences}
    />
  );
}

export const Route = createFileRoute('/(client)/orders/(pages)/(list)')({
  component: OrdersLayoutPage,
});
